var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumantaion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2031 11.1367V20.2656C20.2031 20.8624 19.9661 21.4347 19.5441 21.8566C19.1222 22.2786 18.5499 22.5156 17.9531 22.5156H7.45312C6.85639 22.5156 6.28409 22.2786 5.86213 21.8566C5.44018 21.4347 5.20312 20.8624 5.20312 20.2656V5.26562C5.20312 4.66889 5.44018 4.09659 5.86213 3.67463C6.28409 3.25268 6.85639 3.01563 7.45312 3.01562H12.082C12.4797 3.01569 12.8611 3.17367 13.1423 3.45484L19.7639 10.0764C20.0451 10.3576 20.2031 10.739 20.2031 11.1367Z",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7031 3.39062V9.01562C12.7031 9.41345 12.8612 9.79498 13.1425 10.0763C13.4238 10.3576 13.8053 10.5156 14.2031 10.5156H19.8281",
    stroke: "#9C4900",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumantaion);
export default __webpack_public_path__ + "static/media/Documantaion.319d2f3953a6a6d93099e2a44b5040d8.svg";
export { ForwardRef as ReactComponent };